import React, { Component } from 'react';
import SangYang from '../../assets/images/sponsors/ssongyoung-logo.png';
import BMW from '../../assets/images/sponsors/bmw-logo.png';
import PM from '../../assets/images/sponsors/pm-logo.png';
import Moulin from '../../assets/images/sponsors/moulin-logo.png';
import Stunas from '../../assets/images/sponsors/stunas-logo.png';
import Sief from '../../assets/images/sponsors/saif-logo.png';
import Orange from '../../assets/images/sponsors/orange-logo.png';

class AboutCatering extends Component {
  render() {
    return (
      <section className={this.props.background} id="about">
        <div className="container mt-5 mb-5">
          <div className="row pt-2 pb-2">
            <span className="col-12 txt-bold-40px txt-white txt-uppercase">Votre événement clés en main</span>
            <p className="col-12 txt-thin">
              C’est la création, la promotion, l’organisation, la gestion d’événements à caractère touristique, festif,
              culturel… autour d’un thème toujours particulier et des services personnalisés pour tout événement privé; soirées
              privées, séminaires, congrès, dîners d’affaires, Team-building, outside catering et autres. Pour tous vos
              événements au sein de nos établissements, nous vous proposons:
              <br />
              Une variété d’artistes et de spectacles assurés par des artistes nationaux et internationaux.
              <br />
              Transports en bus, minibus et voitures individuelles.
              <br />
              Logement à l’hôtel Golf Résidence El Kantaoui, à l’hôtel Sindbad Sousse ou aux Apparts-Hôtel du QG à des tarifs
              promotionnels.
              <br />
            </p>
            <hr className="rule-white" />
            <br />
            <p className="col-12 txt-thin">Nos references</p>
            <div className="col-12 sponsors">
              <div className="row">
                <div className="col">
                  <img className="sponsor-img" src={Moulin} />
                </div>
                <div className="col">
                  <img className="sponsor-img" src={SangYang} />
                </div>
                <div className="col">
                  <img className="sponsor-img" src={BMW} />
                </div>
                <div className="col">
                  <img className="sponsor-img" src={PM} />
                </div>
                <div className="col">
                  <img className="sponsor-img" src={Stunas} />
                </div>
                <div className="col">
                  <img className="sponsor-img" src={Sief} />
                </div>
                <div className="col">
                  <img className="sponsor-img" src={Orange} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default AboutCatering;



// WEBPACK FOOTER //
// ./src/components/catering/AboutCatering.js